// PageJS
var window_width		= window.innerWidth;
var whCookies			= whCookies || {};

$(document).ready(function() {
	$("area.external, a[rel=external]").attr("target", "_blank");
	$("a[rel=top]").attr("target", "_top");
	$("a[rel=self]").attr("target", "_self");
	// INIT Functions
	init_menu_overlay();
	// Search Bar
	init_search_bar();
	if ( window_width >= 1400 ) {
		init_typeahead();
	} else {
		init_mobile_typeahead();
	}
	// WhCookieManager
	init_wh_cookie_manager();
	// Lazy Loading
	init_images();
});

// Show Main Menu Overlays on Click
function init_menu_overlay(){
	var active_id = 0;
	$(".header-navigation-menu").on('click', function(e) {
		_this = $(this);
		if (!_this.hasClass("clicked") && !_this.hasClass("clickable")) {
			e.preventDefault();
			$("a.header-navigation-menu.active").removeClass("active");
			$(".header-navigation-overlay").slideUp(100);
			_this.addClass("clicked");
			_this.addClass("active");
			_this.parent().addClass("active-li");
			var overlay_id = _this.data('overlay');
			$("body").append('<div class="closing_menu_wrapper" onclick="close_menu_overlay();"></div>');
			if (!isNaN(overlay_id) && overlay_id > 0) {
				$("#header_navigation_overlay_"+overlay_id).slideDown(100);
			}
		}
	});
	$(".header-navigation-overlay .close").on('click', function(e) {
		close_menu_overlay();
	});
}

function load_widget(widget_id,blocked,consent) {
  var blocked = true;
  if (consent == 1) {
    blocked = false;
  }
  if (consent === 3 && whCookies.accepted_statistics === true) {
    blocked = false;
  }
  if (consent === 2 && whCookies.accepted_marketing === true) {
    blocked = false;
  }
  $.ajax({
    type: 'GET'
    ,url: '/ajax/text_bild_widget'
    ,data: 'widget_id=' + widget_id + '&blocked=' + blocked + '&consent' + consent
    ,cache: false
    ,async: false
    ,success: function(html,textStatus) {
      $("#widget-id-" + widget_id).html(html);
    }
    ,error: function (XMLHttpRequest, textStatus, errorThrown) {
      alert("Beim Laden ist ein Fehler aufgetreten.");
    }
  });
}

function udpdate_cookie_consent(widget_id,blocked,consent) {
  // whCookies.set_specific_cookie("statistic");
  // whCookies.accepted_statistics = true;
  // window.location.reload();
  // load_widget(widget_id,blocked,consent);
  event.preventDefault();
  whCookies.show_dialog();
}

// Close Overlay Menue
function close_menu_overlay() {
	setTimeout(function(){
		$(".closing_menu_wrapper").remove();
	},10)
	$(".closing_menu_wrapper").remove();
	$(".menu-to-hover").removeClass("active-li");
	$(".header-navigation-menu.active").removeClass("clicked");
	$(".header-navigation-overlay").slideUp(100);
}

function init_search_bar() {
	$("#search-button-click").on('click', function(e) {
		$("#search-overlay").removeClass("d-none");
		$("#search-overlay").removeClass("d-sm-none");
		$("#search-overlay").slideDown("slow");
		$("#search-button-click").hide();
		$("#shopping-cart-click").hide();
	});
	// restriction for default value search
	$("#header form.search-form").on('submit', function(e) {
		check_search_input(e);
	});
	$("#header form.search-form button[type=submit]").on('click', function(e) {
		check_search_input(e);
	});
	function check_search_input(e) {
		_form	= $("#header form.search-form");
		_input	= _form.find('input.search-field');
		// check if value is eq 'Suchen'
		if (_input.val().trim() == 'Suchen' || _input.val().trim().length < 2) {
			e.preventDefault();
		}
	}
}

// Get the header
var header = document.getElementById("fixed-header");
// Get the offset position of the navbar
var sticky = header.offsetTop;

// When the user scrolls the page, execute myFunction
window.onscroll = function() {
	addStickyClass();
};
// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function addStickyClass() {
	if (window.pageYOffset > sticky) {
		header.classList.add("sticky");
	} else {
		header.classList.remove("sticky");
	}
}

function set_header_menu_active(page_id){
	$("a[content-id='" + page_id + "']").addClass('active');
}

function init_sidebar(){
	if ($("#page").css("position") == "fixed") {
		close_sidebar();
	} else {
		$("#page").css("position", "fixed");
		$("#page").css("transform", "translate3d(-100px,0,0)");
		$("#sidebar").css("transform", "translate3d(0px,0,0)");
		$("#sidebar").css("display", "block");
	}
}

function close_sidebar(){
	$("#page").css("position", "relative");
	$("#page").css("transform", "translate3d(0px,0,0)");
	$("#sidebar").css("transform", "translate3d(-100px,0,0)");
	$("#sidebar").css("display", "none");
}

function init_typeahead(){
	$('#search-input-box input').unbind();

	$('#search-input-box input').each(function(){
		$(this).wh_typeahead({
			ajaxurl: 		"/ajax/typeahead"
			,top: 			36
			,left: 			-105
			,container: 	"#search-input-box"
			,width: 		740
			,sprache:		language
		});
	});
}

function init_mobile_typeahead(){
	$('#search-input-mobile-box input').unbind();

	$('#search-input-mobile-box input').each(function(){
		$(this).wh_typeahead({
			ajaxurl: 		"/ajax/typeahead"
			,top: 			50
			,right: 		0
			,container: 	"#search-input-mobile-box"
			,width: 		"75%"
		});
	});
}

// WHCookieManager Init Function
function init_wh_cookie_manager(send_pageview=true) {
	// -- options
	const whCookiesOptions = {
		headline:			$("#whCookieManagerOptions").data('headline'),
		text:				$("#whCookieManagerOptions").data('text'),
		details: $("#whCookieManagerOptions").data('detailtext'),
		boxes: {
			required:		$("#whCookieManagerOptions").data('requiredbox'),
			statistic:		$("#whCookieManagerOptions").data('statisticbox'),
		},
		buttons: {
			selected:	$("#whCookieManagerOptions").data('btnspecific'),
			all:		$("#whCookieManagerOptions").data('btnall'),
			decline:	$("#whCookieManagerOptions").data('btndecline'),
		},
		gaProperty:			$("#whCookieManagerOptions").data('gaprop'),
		cartPageCompleted: 	$("#whCookieManagerOptions").data('completepagecart')
	};
	// init cookie manager
	whCookies = new whCookieManager({
		'headline':						whCookiesOptions.headline,
		'text':							whCookiesOptions.text,
	'details_label': 'Details',
	'details': whCookiesOptions.details,
		'categories': {
			'necessary_label':			whCookiesOptions.boxes.required,
			'statistics':				true,
			'statistics_label':			whCookiesOptions.boxes.statistic,
			'marketing':				true,
			'marketing_label':			'Marketing',
		},
		'show_checkboxes':				true,
		'buttons': {
			'select_specific_label':	whCookiesOptions.buttons.selected,
			'select_all_label':			whCookiesOptions.buttons.all,
			'show_decline_all_label':	true,
			'decline_all_label':		whCookiesOptions.buttons.decline
		},
    'cookie_attributes': {
      'secure':       false,
      'samesite':   'lax'
    }
	}, function load_scripts() {
		// check if statistic is accepted
		if (whCookies.accepted_statistics) {
			wh_cookie_manager_statistics(send_pageview,whCookiesOptions.cartPageCompleted);
		}
		window.location.reload();
	});
	// Already accepted?
	if (whCookies.accepted_statistics) {
		wh_cookie_manager_statistics(send_pageview,whCookiesOptions.cartPageCompleted);
	}
	// Eventlistener for Edit Link in Footer
	$("#change-cookie-settings").on('click', function(e) {
		e.preventDefault();
		whCookies.show_dialog();
	});
	// WH-Cookie-Manager -> accepted statistics function
	function wh_cookie_manager_statistics(send_pageview=true,cartPageCompleted=0) {
		// check environment = production
		if ($('#whCookieManagerOptions').length > 0 && $('#whCookieManagerOptions').hasClass("prod")) {
			// script already loaded? -> no -> load script
			if ($("head .gascriptloaded").length == 0) {
				// load ga script
				var ga_script = document.createElement('script');
				ga_script.setAttribute('src',		'https://www.google-analytics.com/analytics.js');
				ga_script.setAttribute('async',		'true');
				ga_script.setAttribute('class',		'gascriptloaded');
				document.head.appendChild(ga_script);
			}
			if (send_pageview) {
				// Google Analytics / Google Tag Manager --> PAGEVIEW
				window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
				//window.ga_debug = {trace: true};
				ga('create',	whCookiesOptions.gaProperty,	'auto');
				if ( cartPageCompleted == 0 ) {
					//ga('set', 	'sendHitTask', 					null);
					ga('set',	'anonymizeIp',					true);
					ga('send',	'pageview');
				}
			}
		}
	}
}

// Lazy Loading
function init_images() {
	$("img:not(.loaded)").each(function(){
		if (!$(this).hasClass("swiper-lazy") && !$(this).hasClass("svg")) {
			$(this).lazyload({
				effect: 		"fadeIn",
				effectspeed: 	200,
				threshold : 	1200,
				event : 		"scroll"
			});
			$(this).addClass("loaded");
		}
	});
}

function show_product_safety() {
  $("#product-safety").toggle();
  if ($("#product-safety:visible").length === 1) {
    $("#product-safety-fa").removeClass("fa-caret-down");
    $("#product-safety-fa").addClass("fa-caret-up");
  } else {
    $("#product-safety-fa").removeClass("fa-caret-up");
    $("#product-safety-fa").addClass("fa-caret-down");
  }
}